import { supabase } from './supabaseClient';
import { segunTienda } from '../utils/tienda';

// "Mi equipo": la dueña invita vendedoras con un enlace (sql/083). Todo pasa
// por RPCs que validan en la BD que quien llama es la dueña y el límite del plan.

const MENSAJES = {
  SOLO_DUENA: 'Solo la dueña del negocio puede administrar el equipo.',
  CORREO_INVALIDO: 'Escribe un correo válido.',
  YA_ES_MIEMBRO: 'Esa persona ya es parte de tu equipo.',
  CORREO_YA_REGISTRADO: 'Ese correo ya tiene una cuenta en Kontrol. Pídele que use otro correo para unirse a tu negocio.',
  LIMITE_USUARIOS: segunTienda('Llegaste al límite de usuarios de tu plan. Sube de plan en "Mi plan" para agregar más.', 'Llegaste al límite de usuarios de tu plan.'),
  CUENTA_PAUSADA: segunTienda('Tu cuenta está pausada. Elige un plan para poder invitar a tu equipo.', 'Tu cuenta está pausada: no puedes invitar a tu equipo por ahora.'),
  NO_PUEDES_QUITARTE: 'No puedes quitarte a ti misma del negocio.',
  NO_ES_DEL_EQUIPO: 'Esa persona ya no es parte de tu equipo.',
};

function traducir(error) {
  const msg = error?.message || '';
  const clave = Object.keys(MENSAJES).find((k) => msg.includes(k));
  return new Error(clave ? MENSAJES[clave] : 'No se pudo completar. Intenta de nuevo.');
}

export const linkInvitacion = (token) => `${window.location.origin}/unirse/${token}`;

export async function listarEquipo() {
  const { data, error } = await supabase.rpc('equipo_listar');
  if (error) throw traducir(error);
  return data;
}

export async function invitar(email) {
  const { data, error } = await supabase.rpc('equipo_invitar', { p_email: email });
  if (error) throw traducir(error);
  return data;
}

export async function cancelarInvitacion(id) {
  const { error } = await supabase.rpc('equipo_cancelar_invitacion', { p_id: id });
  if (error) throw traducir(error);
}

export async function quitarMiembro(userId) {
  const { error } = await supabase.rpc('equipo_quitar', { p_user: userId });
  if (error) throw traducir(error);
}

// La dueña guarda los permisos de una persona del equipo ({ clave: true }).
export async function guardarPermisos(userId, permisos) {
  const { data, error } = await supabase.rpc('equipo_permisos', { p_user: userId, p_permisos: permisos });
  if (error) throw traducir(error);
  return data;
}

export async function verInvitacion(token) {
  const { data, error } = await supabase.rpc('invitacion_ver', { p_token: token });
  if (error) return null;
  return data;
}
